export const FETCH_END = 'setResults';
export const FETCH_START = 'setLoading';
export const PURGE_AUTH = 'logOut';
export const SET_AUTH = 'setUser';
export const SET_TOKEN = 'setToken';
export const SET_ERROR = 'setError';
export const SET_PRODUCTS = 'setProducts';
export const SET_CURRENT_PRODUCT = 'setProduct';
export const SET_CURRENT_CATEGORY = 'setCategory';
